/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import BestNoteTakingApps from "views/articles/BestNoteTakingApps"
import Link from "next/link"
import { AppInterface } from "types/types"
import AppsListItem from "components/AppsListItem"

const AddAppollowToYourHomeScreenTR = ({ apps }: { apps: AppInterface[] }) => {
  const article = BestNoteTakingApps["tr"]
  return (
    <InstantArticle {...article}>
      <div style={{ textAlign: "justify" }}>
        <p>
          Daha iyi notlar almanıza ve basitleştirilmiş yapılacaklar listeleri
          oluşturmanıza yardımcı olmak için, notlarınızı bir profesyonel gibi
          yazabilmeniz için fiyatlandırma, incelemeler, özellikler ve uyumluluğa
          dayalı olarak iPad için en iyi not alma uygulamalarını bir araya
          getirdik.
        </p>
        <h2>Noteability</h2>
        <p>
          Notability, basit bir arayüz ve güçlü yetenekler sunan, oldukça saygın
          bir not uygulamasıdır. Kullanıcılar notlarına ses ve video gibi
          multimedya öğeleri ekleyebilir ve uygulama çeşitli biçimlendirme
          araçları içerir. Birkaç farklı türde not alma uygulamasını birleştirir
          ve günlük oluşturma, mürekkep araçları ve fosforlu kalemler gibi
          özellikler sunar. Ancak uygulama, ücretli bir Plus üyelik aboneliği
          gerektirir ve belge boyutları sınırlıdır.
        </p>

        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 360593530)} />
        </div>
        <h2>Microsoft OneNote</h2>
        <p>
          Microsoft OneNote ücretsiz bir not uygulamasıdır. Notlar, alt not
          defterleri ve alt sayfalar oluşturma özelliği ile not defterleri,
          bölümler ve sayfalar tarafından düzenlenir. Kullanıcılar metin, dosya
          ekleyebilir, çizim yapabilir, kağıt stillerini değiştirebilir ve ses
          kaydı yapabilir. Uygulama ayrıca, parıltı seçenekleri de dahil olmak
          üzere farklı renklerle özelleştirilebilen, basınca duyarlı bir kalem
          aracı ve vurgulayıcı sunar. Ek olarak, kullanıcılar araç çubuğuna
          sınırsız sayıda favori kalem ve keçeli kalem kaydedebilir.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 410395246)} />
        </div>
        <h2>CollaNote</h2>
        <p>
          CollaNote, çok çeşitli işlevler sunan ücretsiz bir not alma
          uygulamasıdır. Klasik bir tükenmez kalem, kurşun kalem, fosforlu
          kalem, kement ve silgi araçlarıyla birlikte gelir ve kullanıcılar
          renkleri özelleştirebilir ve en sevdikleri renk kombinasyonlarını ve
          kalınlıklarını kaydedebilir. Uygulama ayrıca bir lazer işaretçi,
          ayarlanabilir cetvel, çıkartmalar, sesli notlar, kağıt türleri için
          şablonlar ve bir dijital günlük içerir. En büyük avantajlarından biri,
          notların başkalarıyla ortak çalışmasına ve herkesin notlarını
          birleştirmesine izin veren ortak çalışma özelliğidir. Ancak, metin
          yazmak veya yazmak için ayrı bir ekran gerektirdiğinden, metin
          aracının kullanımı kolay değildir.
        </p>

        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1540956268)} />
        </div>
        <h2>Notebook by Zoho</h2>
        <p>
          Defter, kullanıcıların yazılı notları elle çizilmiş şemalar veya el
          yazısı notlarla birleştirmesine olanak tanıyan bir uygulamadır.
          Uygulama, kalem, tükenmez kalem ve fosforlu kalem renklerinin tam
          olarak özelleştirilmesini sunar. Ayrıca, doğrudan açıklama eklemek
          için belirli notları kilitleme ve belgeleri tarama gibi özelliklere de
          sahiptir. Bununla birlikte, Defter&apos;in dezavantajı, el yazısı
          notların diğer not türlerinden ayrı tutulmasıdır, bu da aynı sayfada
          farklı not türlerini karıştırmayı sevenler için daha az kullanışlı
          hale getirir.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 973801089)} />
        </div>
        <h2>Apple Notes</h2>
        <p>
          Apple&apos;ın varsayılan Notlar uygulaması, kalem, fosforlu kalem,
          kurşun kalem, silgi, kement aracı ve ayarlanabilir bir cetvel gibi
          temel araçlarla birlikte gelen kullanışlı bir not alma uygulamasıdır.
          Ayrıca farklı kağıt stilleri ve telefonun kamerasını kullanarak belge
          tarama özelliği de vardır. Taranan belgeler ek olarak saklanır ve
          kalemle işaretlenemez. Uygulama aynı zamanda birden fazla cihaz
          arasında senkronizasyona ve Apple Pencil ile el yazısına izin verir.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1110145109)} />
        </div>

        <div className="card mt-4">
          <div className="card-body">
            <div className="text-center">
              <i className="fa fa-star color-yellow-dark fa-2x mb-3 "></i>
            </div>
            <p className="color-white">
              Kullandığınız herhangi bir favori uygulamanız var mı? Favori
              uygulamalarınızı Appollow&apos;un{" "}
              <Link href="/submit">
                <span className="text-white text-decoration-underline">
                  paylaşım sayfası
                </span>
              </Link>{" "}
              aracılığıyla gönderebilirsiniz.
            </p>
          </div>
          <div className="card-overlay bg-highlight opacity-95" />
          <div className="card-overlay dark-mode-tint" />
        </div>
      </div>
    </InstantArticle>
  )
}

export default AddAppollowToYourHomeScreenTR
